export default __webpack_public_path__ + "static/media/WindCreekW.35ca7c00.png";